import React from 'react';

function MoneyIcon ({ width = 29, height = 19, ...props }) {
  return (
    <svg width={width} height={height} {...props} viewBox="0 0 29 19">
      <g>
        <path d="M0,18.0615 L0,-0.0005 L28.194,-0.0005 L28.194,18.0615 L0,18.0615 Z M27.194,17.0615 L27.194,0.9995 L1,0.9995 L1,17.0615 L27.194,17.0615 Z" />
        <path d="M18.7074,9.0308 C18.7074,6.48494237 16.6432576,4.4208 14.0974,4.4208 C11.5506819,4.4208 9.4864,6.48480289 9.4864,9.0308 C9.4864,11.5767971 11.5506819,13.6408 14.0974,13.6408 C16.6432576,13.6408 18.7074,11.5766576 18.7074,9.0308 Z M19.7074,9.0308 C19.7074,12.1289424 17.1955424,14.6408 14.0974,14.6408 C10.9984274,14.6408 8.4864,12.1291121 8.4864,9.0308 C8.4864,5.93248788 10.9984274,3.4208 14.0974,3.4208 C17.1955424,3.4208 19.7074,5.93265763 19.7074,9.0308 Z" />
      </g>
    </svg>
  );
}

export default MoneyIcon;
